import React from "react";
import Sidebar from "./Sidebar";
import { StepList, SectionTitle } from "./StepList";
import { FadeUp } from "./AnimationLibrary";

const MainContent = props => {
	return (
		<section className="page-content">
			<div className="container column-grid">
				{props.step && props.showStepProgress ? <StepList step={props.step} /> : ""}
				<div className="main-content-area">
					<div className="main-content-area__wrapper">
						<FadeUp>
							{props.step ? <SectionTitle step={props.step} showStepProgress={props.showStepProgress}/> : ""}
							{props.children}
						</FadeUp>
					</div>
				</div>
				{props.sideBar && <Sidebar user={props.user} />}
			</div>
		</section>
	);
};

export default MainContent;
